import BackButton from "Components/BackButton/BackButton";
import Footer from "Components/Footer/Footer";
import Header from "Components/Header/Header";
import React from "react";
import { useState, useRef, useEffect } from "react";
import "./Payment.css";
import { onlinePayment, applyCoupon } from "../../API/post.api";
import { useDispatch, useSelector } from "react-redux";
import { setAlert } from "../../Redux/Actions/alert.action";
import { useNavigate, useLocation } from "react-router-dom";
import CryptoJS from "crypto-js";
import Pesopay from "Assests/Images/Pesopay-logo 1.png";
import onlinepayment from "Assests/Images/online-payment.svg";
import { setUserCartRef } from "../../Redux/Actions/set.action";
import ThankOffline from "Components/Popup/ThankYou/ThankOffline";
import qr from "Assests/Images/qr_code.png";

const Payment = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [show, setShow] = useState(false);
  const [coupon, setCoupon] = useState("");
  const [finalTotal, setFinalTotal] = useState({});
  const testList = useSelector((state) => state.setCartDataReducer?.tests);
  const orderId = useSelector((state) => state.setOrderId);

  const [selectedPayment, setSelectedPayment] = useState(1);
  const token = localStorage.getItem("access_token");
  const tAmount = useSelector((state) => state.setCartTotalAmount);

  const home = testList?.home ? testList?.home : [];
  const lab = testList?.lab ? testList?.lab : [];

  let outSorcetotalData = lab.reduce((accu, curr) => {
    return accu + curr.mrp;
  }, 0);

  let hometotalData = home.reduce((accu, curr) => {
    return accu + curr.mrp;
  }, 0);

  // const min = 10000000000000; // Smallest 14-digit number
  // const max = 99999999999999; // Largest 14-digit number
  const randomNumber = orderId

  const inputString = `18160818|${orderId}|608|${
    finalTotal.total ? finalTotal.total : outSorcetotalData + hometotalData
  }|N|u6WZonVNABMoeCER1Z2OVUWM3ykDLe7s`;

  const sha1Hash = CryptoJS.SHA1(inputString).toString(CryptoJS.enc.Hex);

  useEffect(() => {
    window.scrollTo(0, 0); // Scrolls to the top of the page when component mounts
  }, []);

  const applyCouponFn = () => {
    if (coupon == "") {
      dispatch(setAlert("error", "Please Enter Coupon Code"));
      return;
    }
    let data = {
      couponCode: coupon,
    };
    const apiStatus = applyCoupon(token, data);
    apiStatus
      .then((response) => {
        console.log("resss", response);
        setFinalTotal(response.data);
        dispatch(setAlert("success", response?.data?.message));
        setCoupon("");
      })
      .catch((err) => {
        console.log(err);
        dispatch(setAlert("error", err?.response?.data?.message));
      });
  };

  const paymentIntegrate = () => {
    if (selectedPayment === 1) {
      document.getElementById("myForm").submit();
      //dispatch(setUserCartRef(randomNumber));
      // let formData = {
      //   merchantId: 18076099,
      //   currCode: "608",
      //   amount: 800,
      //   payType: "N",
      //   payMethod: "ALL",
      //   mpsMode: "NIL",
      //   lang: "E",
      //   orderRef: "20230823110159",
      //   secureHash: sha1Hash,
      //   successUrl: "https://www.google.com/",
      //   failUrl: "https://in.search.yahoo.com/?fr2=inr",
      //   errorUrl: "https://www.msn.com/en-in",
      // };
      //navigate("/form");
      //const apiStatus = onlinePayment(token, formData);
      //   apiStatus
      //     .then((response) => {
      //       console.log("resss",response)
      //       return <div dangerouslySetInnerHTML={{ __html: response }} />
      //       dispatch(setAlert("success", response?.data?.message));
      //     })
      //     .catch((err) => {
      //       console.log(err);
      //       dispatch(setAlert("error", err?.response?.data?.message));
      //     });
      // } else {
      // }
    } else {
      setShow(true);
    }
  };

  const Form = () => {
    return (
      <div>
        <form
          id="myForm"
          name="payFormCcard"
          method="post"
          style={{ display: "none" }}
          action="https://www.pesopay.com/b2c2/eng/payment/payForm.jsp"
          // action="https://test.pesopay.com/b2cDemo/eng/payment/payForm.jsp"
          //action="https://www.pesopay.com/b2c2/eng/payment/payForm.jsp"
          //action="https://www.pesopay.com/b2c2/eng/directPay/payComp.jsp"
        >
          <table>
            <tr>
              <td align="center" colspan="2">
                Required Parameter ( with UTF-8 Encoding ) for connect to our
                payment page
              </td>
            </tr>
            <tr>
              <td align="right">merchantId:</td>
              <td align="left">
                <input
                  type="text"
                  name="merchantId"
                  value="18160818"
                  //value="18076099"
                />{" "}
              </td>
            </tr>
            <tr>
              <td align="right">amount:</td>
              <td align="left">
                <input
                  type="text"
                  name="amount"
                  value={
                    finalTotal.total
                      ? finalTotal.total
                      : outSorcetotalData + hometotalData
                  }
                />
              </td>
            </tr>
            <tr>
              <td align="right">orderRef:</td>
              <td align="left">
                <input type="text" name="orderRef" value={orderId} />
              </td>
            </tr>
            <tr>
              <td align="right">currCode:</td>
              <td align="left">
                <input type="text" name="currCode" value="608" />
              </td>
            </tr>
            <tr>
              <td align="right">successUrl:</td>
              <td align="left">
                <input
                  type="text"
                  name="successUrl"
                  // value={`${window.location.origin}/thankyou`}
                  value="https://stemzbe.kodehash.in/cart/online-payment-success"
                  // value="http://localhost:3002/cart/online-payment-cancel"
                  //value="https://www.phisantediagnostics.com/thankyou"
                />
              </td>
            </tr>
            <tr>
              <td align="right">failUrl:</td>
              <td align="left">
                <input
                  type="text"
                  name="failUrl"
                  value="https://stemzbe.kodehash.in/cart/online-payment-failed"
                  // value="http://localhost:3002/cart/online-payment-cancel"
                  // value={`${window.location.origin}/cancel`}
                />
              </td>
            </tr>
            <tr>
              <td align="right">cancelUrl:</td>
              <td align="left">
                <input
                  type="text"
                  name="cancelUrl"
                  // value={`${window.location.origin}/cancel`}
                  // value="http://localhost:3002/cart/online-payment-cancel"
                  value="http://stemzbe.kodehash.in/cart/online-payment-cancel"
                  //value="https://www.phisantediagnostics.com/cancel"
                />
              </td>
            </tr>
            <tr>
              <td align="right">payType:</td>
              <td align="left">
                <input type="text" name="payType" value="N" />
              </td>
            </tr>
            <tr>
              <td align="right">lang:</td>
              <td align="left">
                <input type="text" name="lang" value="E" />
              </td>
            </tr>
            <tr>
              <td align="right">mpsMode:</td>
              <td align="left">
                <input type="text" name="mpsMode" value="NIL" />
              </td>
            </tr>
            <tr>
              <td align="right">payMethod:</td>
              <td align="left">
                <input type="text" name="payMethod" value="ALL" />
              </td>
            </tr>
            <tr>
              <td align="center" colspan="2">
                Optional Parameter for connect to our payment page
              </td>
            </tr>

            <tr>
              <td align="right">secureHash:</td>
              <td align="left">
                <input type="text" name="secureHash" value={sha1Hash} />
              </td>
            </tr>
            <tr>
              <td align="right">remark:</td>
              <td align="left">
                <input type="text" name="remark" value="" />
              </td>
            </tr>
            <tr>
              <td align="right">redirect:</td>
              <td align="left">
                <input type="text" name="redirect" value="" />
              </td>
            </tr>
            <tr>
              <td align="right">oriCountry:</td>
              <td align="left">
                <input type="text" name="oriCountry" value="" />
              </td>
            </tr>
            <tr>
              <td align="right">destCountry:</td>
              <td align="left">
                <input type="text" name="destCountry" value="" />
              </td>
            </tr>

            <tr>
              <td colspan="2" align="center">
                <button type="submit">Submit</button>
              </td>
            </tr>
          </table>
        </form>
      </div>
    );
  };

  function section1() {
    return (
      <>
        <BackButton />

        <div className="wrapper">
          <div>
            <h4>Select payment method</h4>
            <div className="payment-method">
              {/* <div
                className={(selectedPayment === 1 && "active").toString()}
                onClick={() => setSelectedPayment(1)}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="48"
                  height="48"
                  viewBox="0 0 48 48"
                  fill="none"
                >
                  <path
                    d="M12 32H16M6 22H42M6 16H42M24 32H32M12.4 38H35.6C37.8402 38 38.9603 38 39.816 37.564C40.5686 37.1805 41.1805 36.5686 41.564 35.816C42 34.9603 42 33.8402 42 31.6V16.4C42 14.1598 42 13.0397 41.564 12.184C41.1805 11.4314 40.5686 10.8195 39.816 10.436C38.9603 10 37.8402 10 35.6 10H12.4C10.1598 10 9.03968 10 8.18404 10.436C7.43139 10.8195 6.81947 11.4314 6.43597 12.184C6 13.0397 6 14.1598 6 16.4V31.6C6 33.8402 6 34.9603 6.43597 35.816C6.81947 36.5686 7.43139 37.1805 8.18404 37.564C9.03968 38 10.1598 38 12.4 38Z"
                    stroke="white"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
                <p>Credit/Debit Card</p>
              </div> */}
              {/* <div
                className={(selectedPayment === 2 && "active").toString()}
                onClick={() => setSelectedPayment(2)}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="48"
                  height="48"
                  viewBox="0 0 48 48"
                  fill="none"
                >
                  <path
                    d="M34.7331 6.8688C34.5087 6.64665 34.2238 6.49569 33.914 6.43486C33.6042 6.37402 33.2833 6.40602 32.9916 6.52683C32.6999 6.64765 32.4504 6.8519 32.2743 7.11397C32.0982 7.37605 32.0035 7.68428 32.0019 8V12.8H20.8019C20.3775 12.8 19.9706 12.9686 19.6705 13.2686C19.3705 13.5687 19.2019 13.9757 19.2019 14.4C19.2019 14.8243 19.3705 15.2313 19.6705 15.5314C19.9706 15.8314 20.3775 16 20.8019 16H33.6019C34.0262 16 34.4332 15.8314 34.7333 15.5314C35.0333 15.2313 35.2019 14.8243 35.2019 14.4V11.8624L42.5395 19.2L35.2019 26.5376V24C35.2019 23.5757 35.0333 23.1687 34.7333 22.8686C34.4332 22.5686 34.0262 22.4 33.6019 22.4H16.0019V17.6C16.0003 17.2843 15.9055 16.976 15.7295 16.714C15.5534 16.4519 15.3039 16.2476 15.0122 16.1268C14.7205 16.006 14.3996 15.974 14.0898 16.0349C13.78 16.0957 13.495 16.2467 13.2707 16.4688L2.07068 27.6688C1.92197 27.8173 1.80399 27.9936 1.72349 28.1877C1.643 28.3818 1.60156 28.5899 1.60156 28.8C1.60156 29.0101 1.643 29.2182 1.72349 29.4123C1.80399 29.6064 1.92197 29.7827 2.07068 29.9312L13.2707 41.1312C13.4944 41.3549 13.7795 41.5072 14.0898 41.5689C14.4002 41.6306 14.7218 41.599 15.0141 41.4779C15.3065 41.3568 15.5563 41.1518 15.7321 40.8887C15.9079 40.6257 16.0018 40.3164 16.0019 40V35.2H27.2019C27.6262 35.2 28.0332 35.0314 28.3333 34.7314C28.6333 34.4313 28.8019 34.0243 28.8019 33.6C28.8019 33.1757 28.6333 32.7687 28.3333 32.4686C28.0332 32.1686 27.6262 32 27.2019 32H14.4019C13.9775 32 13.5706 32.1686 13.2705 32.4686C12.9705 32.7687 12.8019 33.1757 12.8019 33.6V36.1376L5.46428 28.8L12.8019 21.4624V24C12.8019 24.4243 12.9705 24.8313 13.2705 25.1314C13.5706 25.4314 13.9775 25.6 14.4019 25.6H32.0019V30.4C32.002 30.7164 32.0958 31.0257 32.2716 31.2887C32.4475 31.5518 32.6973 31.7568 32.9896 31.8779C33.282 31.999 33.6036 32.0306 33.9139 31.9689C34.2243 31.9072 34.5093 31.7549 34.7331 31.5312L45.9331 20.3312C46.0818 20.1827 46.1998 20.0064 46.2803 19.8123C46.3608 19.6182 46.4022 19.4101 46.4022 19.2C46.4022 18.9899 46.3608 18.7818 46.2803 18.5877C46.1998 18.3936 46.0818 18.2173 45.9331 18.0688L34.7331 6.8688Z"
                    fill="#5E5E5E"
                  />
                </svg>
                <p>Bank Transfer</p>
              </div> */}
              <div
                className={(selectedPayment === 1 && "active").toString()}
                onClick={() => setSelectedPayment(1)}
              >
                <img
                  src={onlinepayment}
                  className="onlinePayment"
                  alt="paseoapy"
                />
                {/* <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="48"
                  height="48"
                  viewBox="0 0 48 48"
                  fill="none"
                >
                  <path
                    d="M40.8757 14.209C40.5303 13.8218 40.1465 13.4708 39.7301 13.1614C39.9011 11.8216 39.7829 10.4607 39.3835 9.17045C38.9841 7.88019 38.3128 6.69053 37.4147 5.68164C35.2468 3.23828 31.5515 2 26.4304 2H14.0026C13.1048 2.00239 12.2371 2.3239 11.5544 2.90708C10.8718 3.49027 10.4187 4.29715 10.2761 5.1836L5.09639 37.9961C5.0231 38.4359 5.04662 38.8864 5.16529 39.3162C5.28397 39.746 5.49494 40.1447 5.78351 40.4846C6.07209 40.8245 6.43131 41.0974 6.83616 41.2842C7.241 41.4711 7.68171 41.5674 8.12759 41.5664H13.4558L13.2918 42.6074C13.2254 43.0262 13.2507 43.4543 13.3657 43.8624C13.4808 44.2704 13.6829 44.6487 13.9582 44.9712C14.2335 45.2936 14.5754 45.5526 14.9603 45.7302C15.3453 45.9078 15.7642 45.9998 16.1882 46H22.6569C23.4949 46.0067 24.3078 45.7144 24.9497 45.1757C25.5915 44.6369 26.0203 43.887 26.1589 43.0605L27.4402 34.998L27.4617 34.8887H28.0593C36.1238 34.8887 41.1609 30.9023 42.6297 23.3633C43.0777 21.807 43.1524 20.1669 42.8477 18.5763C42.5429 16.9857 41.8673 15.4894 40.8757 14.209ZM15.6862 27.4082L14.2573 36.4788L14.0847 37.5664H9.21359L14.196 6H26.4304C30.3015 6 33.0651 6.8086 34.4147 8.32812C35.0518 9.06881 35.4961 9.95534 35.7082 10.909C35.9203 11.8627 35.8936 12.8539 35.6306 13.7948L35.5933 14.0193C35.569 14.1722 35.5469 14.3217 35.5065 14.5117C35.1208 17.3696 33.6926 19.984 31.4963 21.8528C29.0306 23.5675 26.059 24.401 23.0612 24.2188H19.4147C18.5143 24.2158 17.6427 24.536 16.9584 25.1214C16.2742 25.7067 15.8228 26.5182 15.6862 27.4082ZM38.7038 22.5977C37.6022 28.2539 34.2194 30.8887 28.0593 30.8887H27.0925C26.2537 30.8822 25.44 31.1752 24.798 31.7152C24.1561 32.2551 23.7279 33.0064 23.5905 33.834L22.2917 41.9824L17.4362 42L18.3925 35.9323L19.6148 28.2266H23.0534C23.367 28.2266 23.6442 28.1794 23.9497 28.1687C24.6673 28.1439 25.3829 28.1163 26.055 28.033C26.4655 27.9818 26.8422 27.8885 27.2357 27.8156C27.7807 27.7148 28.3261 27.6152 28.8378 27.473C29.2186 27.367 29.5738 27.2306 29.936 27.1018C30.4145 26.932 30.8856 26.7538 31.3311 26.5444C31.6671 26.3862 31.9873 26.2103 32.3043 26.0299C32.7263 25.7909 33.1351 25.5293 33.529 25.2465C33.8136 25.0413 34.0928 24.8307 34.359 24.6045C34.7364 24.2792 35.0949 23.9327 35.4329 23.5666C35.6589 23.3255 35.8903 23.0915 36.0995 22.8321C36.4467 22.3898 36.7672 21.9272 37.0595 21.4469C37.2124 21.2025 37.382 20.9764 37.5227 20.7192C37.9279 19.9779 38.2761 19.2068 38.5642 18.4127C38.5816 18.365 38.6064 18.3247 38.6233 18.2767C38.6313 18.2542 38.6431 18.2355 38.651 18.213C39.0473 19.6454 39.0655 21.1561 38.7038 22.5977Z"
                    fill="#5E5E5E"
                  />
                </svg> */}
                <p>Online Payment</p>
              </div>
              <div
                className={(selectedPayment === 2 && "active").toString()}
                onClick={() => setSelectedPayment(2)}
                style={{ marginLeft: "20px" }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="48"
                  height="48"
                  viewBox="0 0 48 48"
                  fill="none"
                  className="onlinePayment"
                >
                  <path
                    d="M38 14.5H36.4L25.4 8.22C24.3519 7.62339 23.1373 7.38642 21.9418 7.54534C20.7464 7.70425 19.6358 8.2503 18.78 9.1L13.38 14.5H12C10.5413 14.5 9.14236 15.0795 8.11091 16.1109C7.07946 17.1424 6.5 18.5413 6.5 20V22.5H6C5.60379 22.5052 5.22526 22.6649 4.94507 22.9451C4.66488 23.2253 4.50518 23.6038 4.5 24V30C4.50518 30.3962 4.66488 30.7747 4.94507 31.0549C5.22526 31.3351 5.60379 31.4948 6 31.5H6.5V34C6.5 35.4587 7.07946 36.8576 8.11091 37.8891C9.14236 38.9205 10.5413 39.5 12 39.5H38C39.4587 39.5 40.8576 38.9205 41.8891 37.8891C42.9205 36.8576 43.5 35.4587 43.5 34V20C43.5 18.5413 42.9205 17.1424 41.8891 16.1109C40.8576 15.0795 39.4587 14.5 38 14.5ZM20.9 11.22C21.2963 10.8142 21.8179 10.5539 22.3805 10.4813C22.9431 10.4087 23.5137 10.528 24 10.82L30.44 14.5H17.62L20.9 11.22ZM7.5 28.5V25.5H12.5V28.5H7.5ZM40.5 34C40.5 34.663 40.2366 35.2989 39.7678 35.7678C39.2989 36.2366 38.663 36.5 38 36.5H12C11.337 36.5 10.7011 36.2366 10.2322 35.7678C9.76339 35.2989 9.5 34.663 9.5 34V31.5H13C13.663 31.5 14.2989 31.2366 14.7678 30.7678C15.2366 30.2989 15.5 29.663 15.5 29V25C15.5 24.337 15.2366 23.7011 14.7678 23.2322C14.2989 22.7634 13.663 22.5 13 22.5H9.5V20C9.5 19.337 9.76339 18.7011 10.2322 18.2322C10.7011 17.7634 11.337 17.5 12 17.5H38C38.663 17.5 39.2989 17.7634 39.7678 18.2322C40.2366 18.7011 40.5 19.337 40.5 20V34Z"
                    fill="#5E5E5E"
                  />
                </svg>
                <p className="offline">Offline Payment</p>
              </div>
            </div>
            {/* <div className="qr-code">
              <img src={qr} alt="qrcode" />
            </div> */}
          </div>

          <div>
            <h4>Summary</h4>
            <div className="summary">
              <div>
                <p>Test</p>
                <span>
                  ₱
                  {finalTotal.total
                    ? finalTotal.total
                    : outSorcetotalData + hometotalData}
                </span>
              </div>

              {/* <div>
                <p>Service Charge</p>
                <span>₱100.00</span>
              </div> */}

              <div>
                <p>Subtotal</p>
                <span>₱{outSorcetotalData + hometotalData}</span>
              </div>
              {finalTotal.couponDiscount && (
                <div className="coupon">
                  <p>Coupon Discount</p>
                  <span>₱{finalTotal.couponDiscount}</span>
                </div>
              )}

              {/* <label>Apply Coupon</label>
              <div className="input-field">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M19.9963 9.54C19.8523 9.4898 19.7207 9.4094 19.6103 9.30419C19.5 9.19899 19.4133 9.07141 19.3563 8.93C19.2896 8.78936 19.255 8.63565 19.255 8.48C19.255 8.32434 19.2896 8.17063 19.3563 8.03C19.5844 7.54575 19.6574 7.00291 19.5655 6.47559C19.4735 5.94828 19.2211 5.46219 18.8426 5.08369C18.4641 4.7052 17.978 4.45275 17.4507 4.36081C16.9234 4.26887 16.3805 4.34193 15.8963 4.57C15.7543 4.63165 15.6011 4.66347 15.4463 4.66347C15.2915 4.66347 15.1383 4.63165 14.9963 4.57C14.8535 4.51245 14.725 4.42449 14.6196 4.31224C14.5143 4.19999 14.4347 4.06614 14.3863 3.92C14.2093 3.42561 13.8856 2.99702 13.4585 2.69146C13.0315 2.3859 12.5213 2.21794 11.9963 2.21C11.4548 2.20135 10.9244 2.36397 10.4809 2.67465C10.0373 2.98532 9.70322 3.42817 9.52628 3.94C9.47449 4.08587 9.3925 4.21916 9.28566 4.33117C9.17882 4.44318 9.04954 4.53138 8.90628 4.59C8.76662 4.65387 8.61485 4.68692 8.46128 4.68692C8.30771 4.68692 8.15594 4.65387 8.01628 4.59C7.53676 4.36819 7.00104 4.29773 6.48047 4.38801C5.95991 4.47828 5.47919 4.72501 5.10236 5.09533C4.72552 5.46565 4.47045 5.94199 4.37111 6.4609C4.27176 6.97982 4.33287 7.51668 4.54628 8C4.615 8.13828 4.65075 8.29059 4.65075 8.445C4.65075 8.59941 4.615 8.75172 4.54628 8.89C4.48923 9.03141 4.40261 9.15899 4.29223 9.26419C4.18186 9.3694 4.05027 9.4498 3.90628 9.5C3.39409 9.68323 2.95292 10.0237 2.64581 10.4727C2.3387 10.9216 2.18136 11.4562 2.19628 12C2.18964 12.5372 2.35217 13.0629 2.66086 13.5026C2.96956 13.9423 3.40877 14.2738 3.91628 14.45C4.06097 14.5023 4.1932 14.5841 4.30458 14.6902C4.41596 14.7964 4.50407 14.9245 4.56331 15.0665C4.62255 15.2085 4.65163 15.3612 4.64869 15.515C4.64576 15.6688 4.61089 15.8204 4.54628 15.96C4.32355 16.4428 4.25421 16.9824 4.34762 17.5059C4.44104 18.0293 4.69271 18.5116 5.06871 18.8876C5.44471 19.2636 5.92696 19.5152 6.45043 19.6087C6.97391 19.7021 7.51344 19.6327 7.99628 19.41C8.13576 19.3455 8.2876 19.3121 8.44128 19.3121C8.59496 19.3121 8.7468 19.3455 8.88628 19.41C9.02954 19.4686 9.15882 19.5568 9.26566 19.6688C9.37249 19.7808 9.45449 19.9141 9.50628 20.06C9.68767 20.5714 10.0263 21.0123 10.4735 21.3194C10.9208 21.6266 11.4539 21.7843 11.9963 21.77C12.5338 21.7638 13.0559 21.5899 13.4898 21.2726C13.9236 20.9553 14.2476 20.5104 14.4163 20C14.4647 19.8539 14.5443 19.72 14.6496 19.6078C14.755 19.4955 14.8835 19.4076 15.0263 19.35C15.1683 19.2883 15.3215 19.2565 15.4763 19.2565C15.6311 19.2565 15.7843 19.2883 15.9263 19.35C16.3994 19.5638 16.9258 19.6305 17.4372 19.5414C17.9486 19.4524 18.4215 19.2117 18.7945 18.8506C19.1674 18.4895 19.4233 18.0246 19.5288 17.5163C19.6343 17.008 19.5847 16.4797 19.3863 16C19.3127 15.8593 19.2701 15.7045 19.2614 15.546C19.2527 15.3875 19.2781 15.2289 19.336 15.0811C19.3938 14.9332 19.4826 14.7995 19.5965 14.6889C19.7105 14.5783 19.8468 14.4934 19.9963 14.44C20.5023 14.2602 20.9402 13.9282 21.25 13.4895C21.5597 13.0508 21.7259 12.527 21.7259 11.99C21.7259 11.453 21.5597 10.9292 21.25 10.4905C20.9402 10.0518 20.5023 9.71976 19.9963 9.54ZM19.5163 13C19.1725 13.1249 18.8592 13.3214 18.5971 13.5765C18.3351 13.8317 18.1303 14.1397 17.9963 14.48C17.8457 14.8113 17.7678 15.1711 17.7678 15.535C17.7678 15.8989 17.8457 16.2587 17.9963 16.59C18.0962 16.7949 18.1288 17.0262 18.0893 17.2507C18.0498 17.4753 17.9402 17.6815 17.7763 17.84C17.6196 18.0066 17.4131 18.1181 17.1878 18.1578C16.9626 18.1974 16.7305 18.1631 16.5263 18.06C16.2039 17.9081 15.8537 17.8244 15.4975 17.8141C15.1414 17.8038 14.7869 17.8671 14.4563 18C14.1209 18.1411 13.8182 18.3498 13.567 18.613C13.3159 18.8763 13.1216 19.1884 12.9963 19.53C12.9244 19.7477 12.7856 19.9372 12.5998 20.0715C12.414 20.2058 12.1906 20.2781 11.9613 20.2781C11.732 20.2781 11.5086 20.2058 11.3227 20.0715C11.1369 19.9372 10.9982 19.7477 10.9263 19.53C10.8059 19.1873 10.6145 18.8738 10.3647 18.6102C10.1148 18.3465 9.81206 18.1386 9.47628 18C9.14078 17.8597 8.7795 17.7917 8.41596 17.8003C8.05242 17.8089 7.69477 17.894 7.36628 18.05C7.16158 18.1478 6.93164 18.18 6.70796 18.142C6.48428 18.104 6.27781 17.9978 6.11684 17.838C5.95586 17.6781 5.84826 17.4724 5.80878 17.2489C5.7693 17.0255 5.79986 16.7954 5.89628 16.59C6.06027 16.2651 6.15394 15.9092 6.17117 15.5457C6.1884 15.1821 6.12881 14.819 5.99628 14.48C5.85467 14.136 5.64141 13.8261 5.37071 13.5709C5.1 13.3157 4.77805 13.1211 4.42628 13C4.21325 12.9233 4.02907 12.7828 3.89887 12.5975C3.76867 12.4123 3.69881 12.1914 3.69881 11.965C3.69881 11.7386 3.76867 11.5177 3.89887 11.3325C4.02907 11.1472 4.21325 11.0067 4.42628 10.93C4.76629 10.8069 5.07701 10.6144 5.33872 10.3649C5.60043 10.1153 5.80742 9.81408 5.94657 9.4803C6.08572 9.14652 6.154 8.78747 6.14706 8.42592C6.14013 8.06436 6.05813 7.70819 5.90628 7.38C5.80537 7.1757 5.77102 6.9449 5.80807 6.72007C5.84512 6.49523 5.9517 6.28766 6.11282 6.12654C6.27395 5.96541 6.48152 5.85883 6.70635 5.82179C6.93119 5.78474 7.16198 5.81909 7.36628 5.92C7.69522 6.0768 8.05344 6.16271 8.41771 6.17215C8.78198 6.1816 9.14417 6.11436 9.48079 5.97481C9.8174 5.83527 10.1209 5.62652 10.3717 5.36211C10.6224 5.0977 10.8148 4.78354 10.9363 4.44C11.0067 4.22968 11.1408 4.04646 11.32 3.91567C11.4991 3.78489 11.7145 3.71302 11.9363 3.71C12.1581 3.71302 12.3734 3.78489 12.5526 3.91567C12.7317 4.04646 12.8658 4.22968 12.9363 4.44C13.0652 4.79417 13.2684 5.11664 13.5323 5.38572C13.7962 5.6548 14.1147 5.86426 14.4663 6C14.8025 6.1387 15.1641 6.20504 15.5277 6.19471C15.8912 6.18437 16.2485 6.09758 16.5763 5.94C16.7778 5.85982 16.9985 5.841 17.2107 5.88592C17.4229 5.93083 17.6171 6.03747 17.7688 6.19243C17.9206 6.34739 18.0231 6.54375 18.0636 6.75683C18.1041 6.96991 18.0807 7.1902 17.9963 7.39C17.8351 7.72364 17.7468 8.08778 17.7372 8.4582C17.7276 8.82862 17.7971 9.19683 17.9409 9.53833C18.0847 9.87984 18.2995 10.1868 18.5712 10.4388C18.8428 10.6909 19.165 10.8822 19.5163 11C19.7293 11.0767 19.9135 11.2172 20.0437 11.4025C20.1739 11.5877 20.2438 11.8086 20.2438 12.035C20.2438 12.2614 20.1739 12.4823 20.0437 12.6675C19.9135 12.8528 19.7293 12.9933 19.5163 13.07V13Z"
                    fill="#2A364E"
                  />
                  <path
                    d="M12.4995 11.25H11.4995C11.3014 11.2474 11.1122 11.1676 10.9721 11.0275C10.832 10.8874 10.7521 10.6981 10.7495 10.5C10.7533 10.3949 10.7782 10.2916 10.8229 10.1963C10.8676 10.1011 10.9311 10.0159 11.0096 9.94582C11.088 9.87576 11.1799 9.82229 11.2795 9.78864C11.3792 9.75498 11.4847 9.74184 11.5895 9.75C11.9692 9.74966 12.3445 9.83153 12.6895 9.99C12.7794 10.0319 12.8767 10.0556 12.9758 10.0596C13.0748 10.0637 13.1737 10.0481 13.2667 10.0137C13.3597 9.97925 13.445 9.92674 13.5176 9.85917C13.5901 9.7916 13.6486 9.71031 13.6895 9.62C13.7714 9.43811 13.7785 9.23131 13.7093 9.04423C13.6401 8.85714 13.5001 8.70477 13.3195 8.62C13.1364 8.54952 12.9494 8.48943 12.7595 8.44V8C12.7595 7.80109 12.6805 7.61032 12.5399 7.46967C12.3992 7.32902 12.2084 7.25 12.0095 7.25C11.8106 7.25 11.6199 7.32902 11.4792 7.46967C11.3386 7.61032 11.2595 7.80109 11.2595 8V8.28C10.6822 8.33359 10.1481 8.609 9.76957 9.04829C9.39107 9.48759 9.19768 10.0565 9.23006 10.6355C9.26244 11.2145 9.51807 11.7583 9.94319 12.1526C10.3683 12.547 10.9298 12.7611 11.5095 12.75H12.5095C12.7076 12.7526 12.8969 12.8324 13.037 12.9725C13.1771 13.1126 13.2569 13.3019 13.2595 13.5C13.2558 13.6051 13.2308 13.7084 13.1862 13.8037C13.1415 13.8989 13.078 13.9841 12.9995 14.0542C12.921 14.1242 12.8292 14.1777 12.7295 14.2114C12.6299 14.245 12.5244 14.2582 12.4195 14.25C12.0398 14.2503 11.6646 14.1685 11.3195 14.01C11.2296 13.9693 11.1325 13.9467 11.0338 13.9435C10.9351 13.9403 10.8368 13.9566 10.7444 13.9914C10.5578 14.0618 10.4068 14.2033 10.3245 14.385C10.2423 14.5667 10.2356 14.7736 10.306 14.9602C10.3763 15.1468 10.5179 15.2978 10.6995 15.38C10.8827 15.4505 11.0696 15.5106 11.2595 15.56V16C11.2595 16.1989 11.3386 16.3897 11.4792 16.5303C11.6199 16.671 11.8106 16.75 12.0095 16.75C12.2084 16.75 12.3992 16.671 12.5399 16.5303C12.6805 16.3897 12.7595 16.1989 12.7595 16V15.72C13.3369 15.6664 13.871 15.391 14.2495 14.9517C14.628 14.5124 14.8214 13.9435 14.789 13.3645C14.7566 12.7855 14.501 12.2417 14.0759 11.8474C13.6508 11.453 13.0893 11.2389 12.5095 11.25H12.4995Z"
                    fill="black"
                  />
                </svg>

                <input
                  type="text"
                  name="coupon"
                  value={coupon}
                  onChange={(e) => setCoupon(e.target.value)}
                  placeholder="Enter Coupon"
                />

                <span onClick={applyCouponFn}>Apply</span>
              </div> */}

              <div className="total">
                <p>Total</p>
                <span>
                  ₱
                  {finalTotal.total
                    ? finalTotal.total
                    : outSorcetotalData + hometotalData}
                </span>
              </div>
            </div>

            <button onClick={paymentIntegrate}>Make Payment</button>
          </div>
        </div>
      </>
    );
  }

  return (
    <>
      <div className="payment-page">
        <Header />

        <div className="section-1">{section1()}</div>
        <Form />
        <Footer />
      </div>
      {show && <ThankOffline show={show} setShow={setShow} />}
    </>
  );
};

export default Payment;
